<template>
	<SmartLayoutC compId="page_container" :mode="layoutMode" key="page_container" />
</template>

<script>
export default {
	name: 'PageFrame'
};
</script>
<script setup>
import { computed } from 'vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import { useStore } from '@/utils/vue-api';
import { useModuleAttrs } from '@rebuild/hooks/useModuleAttrs';
import { useDisplayLogic } from '@rebuild/materials/shared/page_container/useDisplayLogic';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';
import { IRSTORE_T_VIEW } from '@/utils/track';

const store = useStore();
const isMobile = computed(() => store.getters.isMobileMode);
const layoutMode = computed(() => (isMobile.value ? 'mob-basic' : 'basic'));

const { menuId, moduleId, displayMenu, displayModule } = useDisplayLogic();
const { isCustomM } = useModuleAttrs();
const addViewTrack = () => {
	const __menuId = menuId.value;
	const __moduleId = moduleId.value;

	if (!__menuId && !__moduleId) return;

	const __menu = displayMenu.value;
	const __module = displayModule.value;

	const params = {
		企业ID: resolveStoreId(),
		页面ID: resolvePageId()
	};

	if (__moduleId) {
		params['浏览模块名称'] = __module.name;
	} else {
		params['浏览模块名称'] = __menu.name;
	}

	params['浏览模块类型'] = __module && isCustomM(__module) ? '自定义模块' : '系统默认模块';

	IRSTORE_T_VIEW(282, { params });
};
addViewTrack();
</script>

<style lang="less" scoped></style>
